var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tooltip',{attrs:{"text":_vm.tooltipContent,"placement":"top"}},[_c('div',{staticClass:"beta-tag-wrapper",attrs:{"tabindex":"0","aria-label":_vm.tooltipContent}},[_c('div',{staticClass:"beta-tag",class:_vm.sizeClass},[_c('span',{staticClass:"beta-text"},[_vm._v("\n        Beta\n      ")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }